<mat-sidenav-container>

  <div id="eguard-main-content">

    <button mat-button class="toggle-button-navbar mat-icon-button ham" (click)="openMenu()" fxHide.gt-mat
      *ngIf="eguardSettings.layout.navigation === 'left' || eguardSettings.layout.navigation === 'top'">
      <!-- <mat-icon *ngIf="navbar && navbar.isClosed" class="menu">menu</mat-icon> -->
    </button>

    <div class="toolbar-separator" fxHide.gt-mat></div>


    <!-- TOOLBAR: Above -->
    <ng-container *ngIf="eguardSettings.layout.toolbar === 'above' && showNav">
      <eguard-toolbar class="above" [ngClass]="eguardSettings.colorClasses.toolbar"></eguard-toolbar>
    </ng-container>
    <!-- / TOOLBAR: Above -->


    <div id="wrapper">

      <!-- NAVBAR: Left -->
      <eguard-navbar-vertical #sidebar [folded]="eguardSettings.layout.navigationFolded" class="left-navbar"
        [ngClass]="eguardSettings.colorClasses.navbar"
        *ngIf="( eguardSettings.layout.navigation === 'left' || eguardSettings.layout.navigation === 'top') && showNav">
      </eguard-navbar-vertical>
      <!-- / NAVBAR: Left -->

      <div class="content-wrapper">

        <!-- TOOLBAR: Below -->
        <ng-container *ngIf="eguardSettings.layout.toolbar === 'below'">
          <eguard-toolbar *ngIf="showNav" class="below" [ngClass]="eguardSettings.colorClasses.toolbar">
          </eguard-toolbar>
        </ng-container>
        <!-- / TOOLBAR: Below -->
        <div id="content">
          <eguard-content></eguard-content>
        </div>
        <!-- FOOTER: Below -->

        <ng-container *ngIf="eguardSettings.layout.footer === 'below'">
          <!-- <eguard-footer class="below" [ngClass]="eguardSettings.colorClasses.footer"></eguard-footer> -->
        </ng-container>

        <!-- / FOOTER: Below -->

      </div>

    </div>

    <!-- FOOTER: Above -->
    <ng-container>
      <!-- <eguard-footer class="above" [ngClass]="eguardSettings.colorClasses.footer" style="height : 30px ">
      </eguard-footer> -->
    </ng-container>
    <!-- FOOTER: Above -->

  </div>

  <!-- QUICK PANEL -->
  <mat-sidenav eguardMatSidenavHelper="quick-panel" align="end">
    <eguard-quick-panel></eguard-quick-panel>
  </mat-sidenav>
  <!-- / QUICK PANEL -->

</mat-sidenav-container>

<eguard-theme-options></eguard-theme-options>


<eguard-custom-loader></eguard-custom-loader>



// WEBPACK FOOTER //
// ./src/app/main/main.component.html